module.exports = __webpack_public_path__ + "static/favicon-e4937317b22fd6bfb32506f81afaa61a.ico";